import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { httpClient } from "@/api/client";
import {
  getAvtalerQueryKey,
  getAvtaleSelskapQueryKey,
  putAvtaleSelskapMutation,
} from "@/api/generated/@tanstack/react-query.gen";
import { useToaster } from "@/features/toaster";
import { formatDateString } from "@/utils";

export const usePutSelskapsAvtale = () => {
  const router = useRouter();
  const toast = useToaster();
  const queryClient = useQueryClient();

  const { mutate, isPending, isError } = useMutation({
    ...putAvtaleSelskapMutation({
      client: httpClient,
    }),
    onSuccess: (res) => {
      const avtalerQueryKey = getAvtalerQueryKey({ client: httpClient });
      const selskapAvtaleQueryKey = getAvtaleSelskapQueryKey({
        path: { id: res.avtale.avtaleId },
        client: httpClient,
      });

      // Remove queries to ensure stale data is not shown
      queryClient.removeQueries({
        queryKey: avtalerQueryKey,
      });
      queryClient.removeQueries({
        queryKey: selskapAvtaleQueryKey,
      });

      const footer =
        res.avtale.lastUpdatedAt != null &&
        formatDateString(res.avtale.lastUpdatedAt);
      toast.success({
        messageKey: "pages.endre.form.suksess.suksess-tittel",
        footer,
      });

      router.navigate({
        to: `/`,
      });
    },
  });

  return { mutate, isPending, isError };
};
